import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { WithdrawSuccess } from '@/features/consumer/withdraw-success';
import { useTrack } from '@/features/tracking/useTrack';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/withdraw/success'
)({
  component: WithdrawSuccessPage,
});

function WithdrawSuccessPage() {
  const navigate = useNavigate();
  const track = useTrack();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => {
            track('click', {
              eventAction: 'clickButton',
              eventCategory: 'addHours',
              eventDescription: 'clickBack',
              eventLabel: 'addHoursCompleted',
              screenName: 'addHoursCompletedPage',
            });
            navigate({ to: '/my-wallet' });
          }}
        />
        <HeaderDashboard.Title>Withdraw</HeaderDashboard.Title>
      </HeaderDashboard>
      <WithdrawSuccess />
    </div>
  );
}
